import React from 'react';
export function ResultsGallery() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1611171711912-e0e5b7f0e9b3?w=600&h=800&fit=crop',
    alt: 'Amigurumi tejido',
    className: 'md:col-span-2 md:row-span-2 aspect-[3/4]'
  }, {
    url: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&h=400&fit=crop',
    alt: 'Flores de crochet',
    className: 'aspect-square'
  }, {
    url: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=400&h=400&fit=crop',
    alt: 'Muñecos tejidos',
    className: 'aspect-square'
  }, {
    url: 'https://images.unsplash.com/photo-1611171711912-e0e5b7f0e9b3?w=400&h=400&fit=crop',
    alt: 'Patrones de crochet',
    className: 'aspect-square'
  }, {
    url: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&h=400&fit=crop',
    alt: 'Accesorios tejidos',
    className: 'aspect-square'
  }];
  return <section className="w-full py-24 px-4 bg-cream" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-textDark mb-4" data-id="element-157">
            Mirá todo lo que vas a poder crear
          </h2>
          <p className="font-body text-xl text-textLight italic" data-id="element-158">
            Inspiración directa a tus manos ✨
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 auto-rows-[200px] md:auto-rows-[250px]" data-id="element-159">
          {images.map((image, index) => <div key={index} className={`rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-500 group ${image.className}`} data-id="element-160">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-161" />
            </div>)}
        </div>
      </div>
    </section>;
}